export default __webpack_public_path__ + "static/rpa-loan-87feb07c077deba117f44eba4b9c3d9f.png";